export const groupAccessEnabled = process.env.REACT_APP_ENABLE_GROUP_AUTHZ === "true";

const visitorGroup = "HRTSI_Resource_Center - htrsi_visitor";

export const visitorPages = new Set([
  "home",
  "access-search",
  "access-request-history",
  "compare-access",
  "security-access-report",
  "entitlement-lookup",
]);

export function getGroupAccess(profile, email) {
  const claims = profile?.kochid_groups;
  const groups = (Array.isArray(claims) ? claims : typeof claims === "string" ? [claims] : [])
    .filter((group) => typeof group === "string")
    .map((group) => group.trim().toLowerCase());
  const superadminEmails = (process.env.REACT_APP_ALLOWED_EMAILS || "")
    .split(",")
    .map((value) => value.trim().toLowerCase())
    .filter(Boolean);

  return {
    superadmin: superadminEmails.includes((email || "").trim().toLowerCase())
      || groups.some((group) => group.includes("hrtsi_superadmin")),
    visitor: groups.includes(visitorGroup.toLowerCase()),
  };
}

export function canAccessPage(page, access) {
  return access.superadmin || (access.visitor && visitorPages.has(page));
}
